import { NgModule } from '@angular/core';
import { MaterialModule } from '../material/material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { LoyalizationComponent } from './loyalization.component';
import { LoyalizationListComponent } from './loyalization-list/loyalization-list.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [BrowserModule, ReactiveFormsModule, MaterialModule, RouterModule, TranslateModule],
  declarations: [LoyalizationComponent, LoyalizationListComponent]
})
export class LoyalizationModule {}



// WEBPACK FOOTER //
// ./src/app/modules/loyalization/loyalization.module.ts